// packages/data/src/components/registry-provider/use-registry.js
import { useContext } from "@wordpress/element";
import { Context } from "./context";
function useRegistry() {
  return useContext(Context);
}
export {
  useRegistry as default
};
//# sourceMappingURL=use-registry.js.map
